export class ApiEndpointInfo
{
    constructor(public name: string, public baseUrl: string)
    {
        this.name = name;
        this.baseUrl = baseUrl;
    }
}
